import React from 'react';
import api from 'controllers/raymanAPI';

function map(item)
{
    return {...item, id: item.locationID, pictureSrc: api.AR.locations.picture.downloadUrl(item.locationID)}
}

async function getData()
{
    let indexed = {};

    let response = await api.AR.locations.getAll();
    let data = await response.json();
    data = data.map((item)=>map(item));
    data.forEach(item => {
        indexed[item.locationID] = item
    });
    
    return {array: data, indexed: indexed};
}

const LocationsCtx = React.createContext({
    loading: true, 
    data: {
        array: [], 
        indexed: {}
    }, 
    funcs: {
        create: () => {},
        update: () => {},
        delete: () => {},
    }
});

function LocationsCtxProvider(props)
{

    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState({array: [], indexed: []});

    React.useEffect(() => {
        getData().then(values => {
            setData(values);
            setLoading(false);
        });
    }, []);

    const internalAdd = React.useCallback(async (locationID) => {
        let tmp = {...data};
        let result = await api.AR.locations.getSingle(locationID);
        if(result.ok)
        {
            let item = map(await result.json());
            let index = tmp.array.push(item);
            tmp.indexed[item.id] = tmp.array[index-1];
            setData(tmp);
        }
    }, [data]);

    const internalUpdate = React.useCallback((locationID, locationData) => {
        let tmp = {...data};
        Object.keys(locationData).forEach((key) => {
            tmp.indexed[locationID][key] = locationData[key];
        })
        setData(tmp);
    }, [data]);

    const internalDelete = React.useCallback((locationID) => {
        let tmp = {...data};
        let item = tmp.indexed[locationID];

        // remove from array
        let index = tmp.array.indexOf(item);
        if(index > -1) tmp.array.splice(index,1);

        delete tmp.indexed[locationID];

    }, [data]);


    const create = React.useCallback(async (data) => {
        let result = await api.AR.locations.post(data);
        if(result.ok)
        {
            let newID = (await result.json()).locationID
            internalAdd(newID);
            return newID;
        }
        else return null;
    }, [internalAdd]);

    const update = React.useCallback(async (locationID, data) => {
        let result = await api.AR.locations.updateSingle(locationID, data);
        if(result.ok) internalUpdate(locationID, data);

    }, [internalUpdate]);

    const remove = React.useCallback(async (locationID) => {
        let result = await api.AR.locations.delete(locationID);
        if(result.ok) internalDelete(locationID);
    }, [internalDelete]);

    return <LocationsCtx.Provider value={{loading: loading, data: {...data}, funcs: {create: create, update: update, delete: remove}}} >
        {props.children}
        </LocationsCtx.Provider>
}


export {LocationsCtx, LocationsCtxProvider};
export {FilesCtx as LocationFilesCtx} from './files';